import { Link } from 'react-router';
import { useAuth } from '@/contexts/auth-context';
import type { CtaDestination } from '@/lib/analytics';

interface SmartCTAProps {
  /** Text shown when user is NOT logged in */
  guestText: string;
  /** Text shown when user IS logged in (defaults to "Go to Dashboard") */
  authText?: string;
  /** Where to send guests (defaults to /check) */
  guestPath?: CtaDestination | `/check?council=${string}`;
  /** Where to send authenticated users (defaults to /dashboard) */
  authPath?: CtaDestination;
  /** Additional CSS classes */
  className?: string;
  /** Optional icon to show after text */
  showArrow?: boolean;
}

/**
 * A CTA button that automatically routes based on authentication state.
 * - Logged out users → guest check
 * - Logged in users → dashboard
 */
export function SmartCTA({
  guestText,
  authText = "Go to Dashboard",
  guestPath = "/check",
  authPath = "/dashboard",
  className = "",
  showArrow = false,
}: SmartCTAProps) {
  const { isAuthenticated } = useAuth();
  const destination = isAuthenticated ? authPath : guestPath;

  return (
    <Link
      to={destination}
      className={className}
    >
      {isAuthenticated ? authText : guestText}
      {showArrow && (
        <svg className="ml-2 w-5 h-5 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
        </svg>
      )}
    </Link>
  );
}
